import * as Yup from 'yup';

export interface RejectValues {
  rejectionMessage: string;
}

export const rejectFormValues: RejectValues = {
  rejectionMessage: '',
};

export const rejectValidationSchema = Yup.object().shape({
  rejectionMessage: Yup.string(),
});

const rejectionDetails = {
  name: 'Rejection Details',
  inputRows: [
    [
      {
        name: 'rejectionMessage',
        label: 'Message',
        type: 'textarea',
        placeholder:
          'Optional. Enter a message to the client about why you’re rejecting their request',
      },
    ],
  ],
};

export const rejectInputGroups = [rejectionDetails];
